<template>
  <div id="ObudowyLista">
    <div id="content">
      <h3>Lista obudów</h3>
      <!-- <pre>
        {{obudowy[0]}}
      </pre> -->
      <!-- <div class="list">
        <md-list :md-expand-single="expandSingle">
          <md-list-item md-expand :md-expanded.sync="expandNews">
            <span class="md-list-item-text">+ dodaj nową centralę</span>

            <md-list slot="md-expand">
              <CentralaDodanie @someEvent="callback"/>
            </md-list>
          </md-list-item>
        </md-list>
      </div> -->

      <vue-good-table
      :columns="columns"
      :rows="obudowy"
      :sort-options="{
        enabled: true,
        initialSortBy: localSort
      }"
      :search-options="{
        enabled: true,
        placeholder: 'Szukaj...'
      }"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        position: 'top',
        perPageDropdown: [40, 80, 100],
        dropdownAllowAll: false,
        nextLabel: '',
        prevLabel: '',
        rowsPerPageLabel: 'Ilość wierszy',
        ofLabel: 'z',
        pageLabel: 'strona',
        allLabel: 'Wszystko'
      }"
      styleClass="vgt-table striped"
      >

        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'img'" style="float: left;margin: 0px;">
              <img
                @click="
                  (showDialog = true),
                    (sourceImg = props.row.symbol + '.jpg')
                "
                :src="
                  'https://lib.pulsar.pl/img/montaz_central/' +
                  props.row.symbol +
                  '.jpg'
                "
                alt=""
                style="max-width: 30px; max-height: 30px; cursor: zoom-in"
              />
            <!-- <button class="btnAction" style="color: #118af4; background:none" @click="editItem(props.row), editPanel = true">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
            </button>
            <button class="btnAction" style="color: red; background:none" @click="deleteItem(props.row)">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
              </svg>
            </button> -->
          </span>
        </template>

      </vue-good-table>

    </div>


    <md-dialog :md-active.sync="showDialog">
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false"
          ><span style="font-weight: bold">X</span></md-button
        >
      </md-dialog-actions>
      <img
        v-bind:src="photo"
        style="
          width: max-content;
          height: 100%;
          margin: 0px auto;
          padding: 20px;
        "
      />
    </md-dialog>

    <!-- <md-dialog-alert
      :md-active.sync="msgBox"
      :md-content="msgInfo"
      md-confirm-text="OK" /> -->

  </div>
</template>

<script>
import { app } from '../mixins/functions'
import { mapGetters } from 'vuex'
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'

export default {
  name: 'ObudowyLista',
  mixins: [app],
  data () {
    return {
      msgBox: false,
      msgInfo: '',
      inputFields: {
        'symbol': ''
      },
      editPanel: false,
      columns: [
        { label: '',field: 'img'},
        { label: 'Symbol',field: 'symbol', width: '220px' },
        { label: 'Nazwa', field: 'nazwa'},
        { label: 'Szerokość',field: 'szerokosc' },
        { label: 'Wysokość',field: 'wysokosc' },
        { label: 'Montaż',field: 'montaz' },
        { label: 'Moc trafo', field: this.fealdFnTrafo },
        { label: 'Akumulatory', field: this.fealdFnBattery }
      ],
      localSort: [
        {field: 'symbol', type: 'asc'}
      ],
      expandNews: false,
      expandSingle: false,
      sourceImg: "",
      showDialog: false,
      showDialogFilters: false
    }
  },
  components: {
    VueGoodTable
  },
  computed: {
    ...mapGetters('products', ['centrale', 'obudowy']),
    photo() {
      return "https://lib.pulsar.pl/img/montaz_central/" + this.sourceImg;
    }
  },
  methods: {
    load_obudowy () {
      this.$store.dispatch('products/load_obudowy_short')
      // this.lista.central = JSON.parse(JSON.stringify(this.centrale))
    },
    deleteItem (item) {
      // let text = "Czy na pewno usunąć centralę";
      // if (confirm(text) == true) {
      //   this.$store.dispatch('products/send_centrale', {'action': 'delete', 'fields': item}).then(info => {
      //     this.msgBox = true
      //     this.msgInfo = info.msg
      //   })
      // } else {

      // }
    },
    editItem (item) {
      // this.inputFields = Object.assign({}, item);
    },
    saveItem (item) {
      // this.editPanel = false
      // this.$store.dispatch('products/send_centrale', {'action': 'edit', 'fields': this.inputFields}).then(info => {
      //   this.msgBox = true
      //   this.msgInfo = info.msg
      // })
    },
    callback (e) {
      // if (e) {
      //   this.expandSingle = false
      //   this.expandNews = false
      //   this.msgBox = true
      //   this.msgInfo = 'Dodano nową centralę do bazy'
      // }
    },
    fealdFnBattery(rowObj) {
      var arr = [1,2,3,4]
      var str = ''
      arr.forEach(id => {
        if (rowObj['akumulator_' + id + '_ah']) {
          str += rowObj['akumulator_' + id + '_ilosc'] + 'x '+ Number(rowObj['akumulator_' + id + '_ah']) + 'Ah, '
        }
      });

      return str;
    },
    fealdFnTrafo(rowObj) {
      if (rowObj.transformator_moc) {
        return Number(rowObj.transformator_moc) + 'W' //field: 'transformator_moc'
      }
    }
  },
  created() {
    this.load_obudowy()
  }
}
</script>

<style scoped>
.btnAction {
	border: none;
	padding: 0px;
}
table tr {
  height: 40px;
}
#content {
  width: 100%;
  margin: 0px auto;
}
#content h3 {
  background: beige;
  padding: 10px;
  font-size: 20px;
  text-transform: uppercase;
}
#content .table {
  margin-top:40px
}
#content .table tr.head {
  background: #3f7bc8;
}
#content .table tr th {
font-size: 14px;
font-weight: normal;
color: #fff;
padding: 4px;
border-left: 2px solid white;
}
.inputWsp {
  width: 80px;
  text-align: left;
  margin: 0px auto;
}
.md-ripple {
  min-height: 30px;
}
#tabPanel tr td input {
  width: 65px;
  padding: 4px;
  text-align: center;
}
.form-select, .form-control {
  padding: 4px 6px;
}
.inputSmall {
  width:65px;
}
.longSmall {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ObudowyLista.vue